export default {
  myProfile: "My Profile",
  notificationSettings: "Notification Settings",
  userRegistration: "User Registration",
};
